import { createSelector } from 'reselect';

import getPickupTimeWithFallback from './getPickupTimeWithFallback';

export default createSelector([getPickupTimeWithFallback], pickupTime => ({
  PickupTime: pickupTime,
}));
